import React, { useState, useRef, useEffect } from 'react';
import Slider from 'react-slick';
import { sliderItems } from './config';
import InterestRatesHistoricalSliderTimeline from './interest-rates-historical-slider-timeline';
import { mainMediaTablet } from '../../../utils';
import useMediaQuery from '../../../hooks/use-media';
import { SharedIconArrowForward } from '../../shared/icons';
import { Link } from '@chakra-ui/react';

interface InterestRatesHistoricalSliderProps {
  title: string;
}

export const InterestRatesHistoricalSlider: React.FC<InterestRatesHistoricalSliderProps> = (
  props
) => {
  const [activeSlideIndex, setActiveSlideIndex] = useState(0);
  const [currentSlideIndex, setCurrentSlideIndex] = useState(0);
  const [isLastItem, setIsLastItem] = useState(false);
  const [isFirstItem, setIsFirstItem] = useState(true);

  const [itemWidth, setItemWidth] = useState(380);
  const sliderRef = useRef<Slider>(null);
  const isMobile = useMediaQuery(mainMediaTablet);

  const handleTimelineItemClick = (index: number) => {
    const count = sliderItems.slice(0, index).reduce((acc, item) => {
      return acc + item.content.length;
    }, 0);

    sliderRef.current?.slickGoTo(count);
  };

  const handleAfterChange = (index: number) => {
    //console.log(`Slider changed to: ${index}`);
    const activeSlide = sliderRef.current?.innerSlider?.list?.querySelector('.slick-active');

    const timeFrameIndex = activeSlide
      ?.querySelector('[data-time-frame-index]')
      ?.getAttribute('data-time-frame-index');

    if (timeFrameIndex) {
      const activeSlideIndex = parseInt(timeFrameIndex);
      setCurrentSlideIndex(index);
      setActiveSlideIndex(activeSlideIndex);
      setIsFirstItem(activeSlideIndex === 0);
      setIsLastItem(activeSlideIndex === sliderItems.length - 1);
    }
  };

  useEffect(() => {
    setItemWidth(isMobile ? 300 : 380);
  }, [isMobile]);

  const settings = {
    className: 'slider variable-width',
    dots: false,
    arrows: false,
    infinite: false,
    centerMode: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    variableWidth: true,
    afterChange: handleAfterChange
  };

  return (
    <>
      <div className="interest-rates-historical-slider">
        <div className={`mb-14 flex justify-between`}>
          <div className={`mr-10`}>
            <h2>{props.title}</h2>
            <p>
              In de hypotheekrente grafiek zie je het verloop van de hypotheekrente vanaf 1984. Hoe
              de rente zich op de lange termijn zal ontwikkelen, valt niet te voorspellen. Onze
              rente-experts delen wel iedere 2 weken hun verwachtingen voor de korte termijn. Wil je
              op de hoogte blijven van de hypotheekrente ontwikkeling? Neem een gratis{' '}
              <Link href={`https://www.hypotheker.nl/rentestandenabonnement`}>
                rentestandenabonnement
              </Link>
              .
            </p>
          </div>
          {!isMobile && (
            <div className={`flex items-end`}>
              <div
                className={`${
                  isFirstItem
                    ? 'bg-gray-200'
                    : 'cursor-pointer border-2 border-blue-500 border-solid'
                } relative rotate-180 mr-2 flex items-center justify-center w-14 h-14 rounded-full`}>
                <SharedIconArrowForward
                  boxSize={`10`}
                  color={`${isFirstItem ? 'gray.400' : 'blue.500'}`}
                  onClick={() => !isFirstItem && sliderRef.current?.slickPrev()}
                />
              </div>
              <div
                className={`${
                  isLastItem
                    ? 'bg-gray-200'
                    : 'cursor-pointer border-2 border-blue-500 border-solid'
                } relative flex items-center justify-center w-14 h-14 rounded-full`}>
                <SharedIconArrowForward
                  boxSize={`10`}
                  color={`${isLastItem ? 'gray.400' : 'blue.500'}`}
                  onClick={() => !isLastItem && sliderRef.current?.slickNext()}
                />
              </div>
            </div>
          )}
        </div>
        <div className={`mb-10`}>
          <InterestRatesHistoricalSliderTimeline
            sliderItems={sliderItems}
            activeSlideIndex={activeSlideIndex}
            currentSlideIndex={currentSlideIndex}
            onTimelineItemClick={(index) => handleTimelineItemClick(index)}
          />
        </div>
        <Slider ref={sliderRef} {...settings}>
          {sliderItems.map((item, index) =>
            item.content.map((content, indexContent) => {
              const isLastItem = indexContent === item.content.length - 1;
              const adjustedWidth = itemWidth + (isLastItem ? 25 : 0);

              return (
                <div
                  key={indexContent}
                  style={{ width: adjustedWidth }}
                  data-time-frame-index={index}>
                  <div className={`flex`}>
                    <div className={`bg-white rounded p-5 min-h-[200px]`}>
                      {/*<div>{item.year}</div>*/}
                      <h3>{content.title}</h3>
                      <div>{content.description}</div>
                    </div>
                    {/*{isLastItem && sliderItems.length - 1 > index && (
                      <div className={`flex flex-col items-center justify-center min-h-[200px]`}>
                        <div
                          className={`w-2 h-2 ml-8 border border-solid border-black bg-black rounded-full`}></div>
                      </div>
                    )}*/}
                  </div>
                </div>
              );
            })
          )}
        </Slider>
      </div>
    </>
  );
};

export default InterestRatesHistoricalSlider;
